/* WJW59B.3 — cosmetic Color-column swatches in mobile Quick Shop only.
   Same explicit full-name mapping as the approved PDP. Does not modify DPO. */
(function () {
  'use strict';
  var colors = {
    'stainless':'linear-gradient(135deg,#eceef0,#b8bfc6)',
    'stainless steel':'linear-gradient(135deg,#eceef0,#b8bfc6)',
    'silver':'linear-gradient(135deg,#eceef0,#b8bfc6)',
    'sterling silver':'linear-gradient(135deg,#eceef0,#b8bfc6)',
    'gold':'linear-gradient(135deg,#f0d999,#c69a3a)',
    'rose':'linear-gradient(135deg,#f3cfc1,#c98a76)',
    'rose gold':'linear-gradient(135deg,#f3cfc1,#c98a76)',
    'black':'linear-gradient(135deg,#4a4a4a,#111)',
    'rainbow':'conic-gradient(#f2a3a3,#f7dd8f,#a8e2b5,#a6cbf0,#c9aee8,#f2a3a3)',
    'blue':'#668dcc', 'white':'#fff', 'purple':'#a68ac7', 'pink':'#eab1ba'
  };
  function colorFor(text) {
    var value=String(text||'').replace(/\s+/g,' ').trim().toLowerCase()
      .replace(/\b(on sale now|back soon|notify me)\b/g,'').trim();
    return colors[value] || '';
  }
  function decorate(table) {
    var headings=Array.from(table.querySelectorAll('thead th'));
    var index=headings.findIndex(function(th){
      return /^colou?r(?:\s*\([^)]*\))?$/i.test((th.textContent||'').trim());
    });
    table.querySelectorAll('tbody tr').forEach(function(row) {
      row.querySelectorAll('td.wjw59b3-color-cell').forEach(function(cell) {
        if (cell.cellIndex !== index || index < 0) {
          cell.classList.remove('wjw59b3-color-cell');
          cell.style.removeProperty('--wjw59b3-swatch');
        }
      });
      if (index < 0) return;
      var cell=row.querySelectorAll('td')[index];
      if (!cell) return;
      var color=colorFor(cell.textContent);
      if (!color && index === 0) color=colorFor(row.getAttribute('o0'));
      if (color) {
        cell.classList.add('wjw59b3-color-cell');
        if (cell.style.getPropertyValue('--wjw59b3-swatch') !== color) {
          cell.style.setProperty('--wjw59b3-swatch', color);
        }
      } else {
        cell.classList.remove('wjw59b3-color-cell');
        cell.style.removeProperty('--wjw59b3-swatch');
      }
    });
  }
  var scheduled=false;
  function scan() {
    scheduled=false;
    if (!window.matchMedia('(max-width:749px)').matches) return;
    document.querySelectorAll('#Product-Drawer.active #bundle-table').forEach(decorate);
  }
  function schedule() {
    if (scheduled) return;
    scheduled=true;
    requestAnimationFrame(scan);
  }
  function setup() {
    new MutationObserver(function(changes) {
      if (changes.some(function(c){
        return c.type === 'childList' ||
          (c.type === 'attributes' && c.target.id === 'Product-Drawer');
      })) schedule();
    }).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
    window.addEventListener('resize', schedule, {passive:true});
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  else setup();
})();
